export interface breadCrumbListJson {
  id: number;
  label: string;
  value: string;
  path?: string;
  scene?: string;
}

export const breadCrumbList: breadCrumbListJson[] = [
  {
    id: 1,
    label: '首页',
    value: '/live/home'
  },
  {
    id: 2,
    label: '全部直播',
    value: '/live/allLive'
  },
  {
    id: 3,
    label: '我的关注',
    value: '/live/follow'
  },
  {
    id: 4,
    label: '赛事直播',
    value: '/competition'
  },
  {
    id: 5,
    label: '详情',
    value: '/studio'
  },
  {
    id: 6,
    label: '主播中心',
    value: '/live/liveRelated'
  },
  {
    id: 7,
    label: '直播搜索',
    value: '/newLive/search'
  },
  {
    id: 8,
    label: '赛事',
    value: '/competition/home',
    path: '/competition/live'
  },
  {
    id: 10,
    label: '游戏详情',
    value: '/gameDetail',
    scene: 'gameDetail'
  },
  {
    id: 11,
    label: '返回上一页',
    value: '/returnPage'
  },
  {
    id: 12,
    label: '首页开服列表',
    value: '/home/homePage'
  },
  {
    id: 1,
    label: '首页',
    value: '/newLive/home'
  },
  {
    id: 2,
    label: '全部直播',
    value: '/newLive/allLive'
  },
  {
    id: 3,
    label: '我的关注',
    value: '/newLive/follow'
  }
];

export const breadCrumbLists: breadCrumbListJson[] = [
  {
    id: 1,
    label: '推荐',
    value: '/live/home'
  },
  {
    id: 3,
    label: '关注',
    value: '/live/follow'
  },
  {
    id: 5,
    label: '详情',
    value: '/studio'
  },
  {
    id: 6,
    label: '主播中心',
    value: '/live/liveRelated'
  },
  {
    id: 7,
    label: '直播搜索',
    value: '/newLive/search'
  },
  {
    id: 8,
    label: '赛事',
    value: '/competition/home',
    path: '/competition/live'
  },
  {
    id: 10,
    label: '游戏详情',
    value: '/gameDetail'
  },
  {
    id: 11,
    label: '返回上一页',
    value: '/returnPage'
  },
  {
    id: 12,
    label: '首页',
    value: '/home/homePage'
  }
];

export const breadCrumbListss: breadCrumbListJson[] = [
  {
    id: 1,
    label: '推荐',
    value: '/newLive/home'
  },
  {
    id: 3,
    label: '关注',
    value: '/newLive/follow'
  },
  {
    id: 5,
    label: '详情',
    value: '/studio'
  },
  {
    id: 6,
    label: '主播中心',
    value: '/live/liveRelated'
  },
  {
    id: 7,
    label: '直播搜索',
    value: '/newLive/search'
  },
  {
    id: 8,
    label: '赛事',
    value: '/competition/home',
    path: '/competition/live'
  },
  {
    id: 10,
    label: '游戏详情',
    value: '/gameDetail'
  },
  {
    id: 11,
    label: '返回上一页',
    value: '/returnPage'
  },
  {
    id: 12,
    label: '首页',
    value: '/home/homePage'
  }
];

export enum LiveAdTypeEnum {
  banner = 128,
  list = 256
}
